DeleteDialog = App.loadClass "core::DeleteDialog"
ScrollHelper = App.load "core::ScrollHelper"
AddMachine = App.loadClass "grower::handlers/machinery/DialogAddMachinery_Handler"
ViewMachine = App.loadClass "grower::handlers/machinery/DialogViewMachinery_Handler"


class exports.Machinery_Handler extends Handler
    init: () ->
        @layoutUrl = 'backend/grower/machinery/load-layout-machinery'
        @layoutSelector = '#sidebar-content'
        @dialogEdit = null
        @singleSubHandler = true
        @loadLayout()
        @deleting = false
        @selected = -1

    deleteThis: (e, obj) ->
        e.preventDefault()

        machinery_id = obj.parents('tr').data('machinery_id')
        machinery_type = obj.parents('tr').data('machinery_type')
        del = @createSubHandler DeleteDialog, 'Delete_Dialog_' + machinery_id
        if del

            #del.layoutUrl = 'backend/grower/machinery/load-layout-delete'
            del.saveUrl             = 'backend/grower/machinery/delete/' + machinery_type
            del.deleteTitle         = 'Machinery'
            del.deleteMessage       = 'this machine'
            del.deleteItemID        = machinery_type + '#' + machinery_id
            del.delayAfterSuccess   = true
            #del.saveData =
            #    id: machinery_id
            del.init()
            del.successAction = () ->
                @parent.refresh()
                # App.current_page.refresh()

    addMachinery: (e, obj) ->
        e.preventDefault()

        add = @createSubHandler AddMachine
        if add
            add.init()


    editMachinery: (e, obj, selector) ->
        e.preventDefault()

        #deselect highlighted items before continuing,
        #this prevents 'stacking' of highlighted machinery
        @afterHiddenMach(e, obj, selector)

        ths = this
        machinery_id = obj.parents('tr').data('machinery_id')
        machinery_type = obj.parents('tr').data('machinery_type')
        ths.selected = machinery_id
        obj.parents('tr').addClass('darken')

        edit = @createSubHandler ViewMachine, 'Grower.Machinery_Handler'
        if edit
            edit.machinery_id = machinery_id
            edit.machinery_type = machinery_type
            edit.saveUrl = 'backend/grower/machinery/save'
            edit.wantEdit = true
            edit.afterHidden = () ->
                if not edit.refreshing
                    ths.afterHiddenMach(e, obj, selector, machinery_id)
            edit.init()

    viewMachinery: (e, obj, selector) ->
        e.preventDefault()
        ths = this
        machinery_id = obj.parents('tr').data('machinery_id')
        machinery_type = obj.parents('tr').data('machinery_type')
        ths.selected = machinery_id
        obj.parents('tr').addClass('darken')

        view = @createSubHandler ViewMachine, 'Grower.Machinery_Handler'
        if view
            view.machinery_id = machinery_id
            view.machinery_type = machinery_type
            view.saveUrl = 'backend/grower/machinery/save'
            view.afterHidden = () ->
                if not view.refreshing
                    ths.afterHiddenMach(e, obj, selector, machinery_id)
            view.init()

    afterHiddenMach: (e, obj, selector, machinery_id) ->
        table = $(selector).find("#machinerylist")
        table.find('tr').removeClass('darken')
        @selected = -1

    viewMachine: (e, obj, selector) ->
        ths = this
        ths.destroySubHandler('Grower.Machinery_Handler', true)
        ths.viewMachinery(e, $(obj), selector)

    afterLoadLayout: (selector, data) ->
        ths = this
        msgwriter = App.sidebar.messageWriter()
        msgwriter.message_writer('success', 'Loaded!', true)

        table = $(selector).find("#machinerylist")

        $(selector).find('.table-container').resizr()

        ScrollHelper.make table,
            height: $(selector).find('.table-container').resizr 'size'
            forceHeight: true
        # ## make the table scrollable ##
        # table.find('.row-clickable, .row-clickable input').bind 'click',(e) ->

        $(window).bind 'resize', debounce (e) =>
            setTimeout () =>
                container = $(selector).find('.table-container')
                container.resizr 'resize'
                size = container.resizr 'size'
                size -= container.find('.dataTables_scrollHead').outerHeight()
                container.find('.dataTables_scrollBody').height size
            , 100
        ScrollHelper.setSaveScroll "machinery", $(selector).find('.dataTables_scrollBody')


        table.find('tbody tr .row-clickable').bind 'click', (e) ->
            if not ths.deleting
                selected = ths.selected
                tr = table.find('tr')
                if tr?.hasClass('darken')
                    # destroy current dialog
                    ths.destroySubHandler('Grower.Machinery_Handler', true)
                    tr.removeClass('darken')
                if $(this).parents('tr').data('machinery_id') isnt selected
                    # show dialog
                    ths.viewMachine e, $(this), selector
                else
                    ths.selected = -1


        ### machinery Details ###
        table.find('.edit-machinery-details-btn').bind 'click', (e) ->
            if not ths.deleting
                ths.editMachinery(e, $(this), selector)


        ### Delete machinery ###
        table.find('.delete-machinery-btn').bind 'click', (e) ->
            ###nav_selected_handler.activeSubHandler.deleteMachinery(e,$(this))###
            ths.deleteThis(e, $(this), selector)


        ### send the call to actually retrieve/populate the list ###
        #$(selector).find('#machinerylist').listitems('list');

        $(selector).find('.add-btn').bind 'click', (e) ->
            ths.addMachinery(e, $(this))


        ### Init multi-deletion ###
        $(selector).find(".btn-multidelete").multidelete
            delUrl: 'machinery/multi-delete'
            dataKey: 'machinery_id'
            dataName: 'name'

            onStart: () ->
                table.find('tr').removeClass('darken')
                ths.destroyAllSubHandlers()
                ths.deleting = true
            afterHidden: () ->
                ths.deleting = false

        # Intercept keypresses on the bulk delete button
        # and prevent multiple dialog spawning
        $(selector).find('.btn-multidelete').keypress (e) ->
            e.preventDefault() if e.which is 13
